import React, { useEffect, useState } from "react";
import useFirebase from "../../../../../useFirebase";
import { useSelector, useDispatch } from "react-redux";
import useCallsAndSms from "./useCallsAndSms";
import { setRuleDataSetUp } from "../../../AxiosRtk/SetRules";

const CallAndSms = ({ deviceSelected, getLangTranslation }) => {
  const [callsAndSmsData, setCallsAndSmsData] = useState(null);
  const [activeTab, setActiveTab] = useState("CONTACTS_TO_MONITOR");
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredContacts, setFilteredContacts] = useState([]);
  const dispatch = useDispatch();

  const {
    handleToggleChange,
    handleAllSelect,
    handleCheckBoxChange,
    handleCallsAndSmsStatusChange,
  } = useCallsAndSms(deviceSelected, callsAndSmsData, setCallsAndSmsData);

  const { getCollectionData } = useFirebase(deviceSelected);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );

  const [isFormChanged, setIsFormChanged] = useState(false); // Track if changes are made

  useEffect(() => {
    if (deviceSelected) {
      getCollectionData(deviceSelected);
    } else {
      dispatch(setRuleDataSetUp(null));
    }
  }, [deviceSelected]);

  useEffect(() => {
    if (setRulesData) {
      setCallsAndSmsData(setRulesData?.callAndSmsMonitoring);
    } else {
      setCallsAndSmsData(null);
    }
  }, [setRulesData]);

  const getDataBySearch = (searchTerm) => {
    const filteredData = callsAndSmsData?.contacts?.filter((item) => {
      const lowerCaseSearchTerm = searchTerm.toLowerCase();
      return (
        item.name.toLowerCase().includes(lowerCaseSearchTerm) ||
        item.number.includes(searchTerm)
      );
    });
    setFilteredContacts(filteredData);
  };

  // console.log(callsAndSmsData?.contacts)

  useEffect(() => {
    // console.log(callsAndSmsData?.contacts)
    if (searchTerm) {
      getDataBySearch(searchTerm);
    } else if (callsAndSmsData && callsAndSmsData?.contacts?.length > 0) {
      setFilteredContacts([...callsAndSmsData?.contacts]);
    }
  }, [searchTerm, callsAndSmsData?.contacts, activeTab]);

  const handleChange = () => {
    setIsFormChanged(true); // Mark form as changed
  };

  if (!deviceSelected) {
    return (
      <div className="text-center my-3">
        -- {getLangTranslation("DEVICE_NOT_SELCTED", "Device not selected")} --
      </div>
    );
  }

  return (
    <>
      <div
        className="alert alert-success alert-dismissible fade show d-flex align-items-center gap-3 mb-6 fw-semibold"
        role="alert"
      >
        <i className="icon-info-one fs-5" />
        {getLangTranslation(
          "CALL_AND_SMS_FEATURE_DESCRIPTION",
          "By enabling this feature, you will be able to monitor all the calls ans SMS of your child."
        )}
        {/* <button
          type="button"
          className="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button> */}
      </div>
      <div className="form-check form-switch mb-6">
        <input
          className="form-check-input cursor-pointer"
          name="CALLS_AND_SMS_ACTIVATE"
          id="CALLS_AND_SMS_ACTIVATE"
          type="checkbox"
          role="switch"
          checked={callsAndSmsData?.callSmsActivate || 0}
          onChange={(e) => {
            handleToggleChange(e);
            handleChange(); // Mark as changed when toggled
          }}
        />
        <label
          className="form-check-label text-blue-800 fw-semibold"
          htmlFor="activate"
        >
          {getLangTranslation(
            "CALL_AND_SMS_FEATURE_ACTIVATE_LABEL",
            "Activate"
          )}
        </label>
      </div>
      <div className="form-check form-switch mb-6">
        <input
          className="form-check-input cursor-pointer"
          name="ALLOW_TO_READ_SMS_CONTENT"
          id="ALLOW_TO_READ_SMS_CONTENT"
          type="checkbox"
          role="switch"
          checked={callsAndSmsData?.allowMeToReadSMSContent || 0}
          onChange={(e) => {
            handleToggleChange(e);
            handleChange(); // Mark as changed when toggled
          }}
        />
        <label className="form-check-label text-dark" htmlFor="smsContent">
          {getLangTranslation(
            "CALL_AND_SMS_ALLOW_ME_TO_READ_SMS_CONTENT_LABEL",
            "Allow me to read SMS content"
          )}
        </label>
      </div>

      <ul className="custom-tab-wrap">
        <li
          className={`custom-tab ${activeTab == "CONTACTS_TO_MONITOR" ? "active-tab" : ""
            }`}
          onClick={() => {
            setActiveTab("CONTACTS_TO_MONITOR");
            setIsFormChanged(true); // Mark form as changed when tab is clicked
          }}
        >
          {getLangTranslation(
            "CALL_AND_SMS_CONTACTS_TO_MONITOR",
            "Contacts to monitor"
          )}
        </li>
        <li
          className={`custom-tab ${activeTab == "ALLOW_BLOCK_CONTACTS" ? "active-tab" : ""
            }`}
          onClick={() => {
            setActiveTab("ALLOW_BLOCK_CONTACTS");
            setIsFormChanged(true); // Mark form as changed when tab is clicked
          }}
        >
          {getLangTranslation("ALLOW_BLOCK_CALLS_TITLE", "Allow/Block calls")}
        </li>
      </ul>

      <div className="d-flex align-items-center justify-content-between flex-wrap gap-6 mb-6">
        <div className="d-flex align-items-center gap-6">
          {activeTab === "CONTACTS_TO_MONITOR" && (
            <div className="form-check">
              <input
                className="form-check-input cursor-pointer"
                name="MONITOR_UNKNOWN_NUMBERS"
                id="MONITOR_UNKNOWN_NUMBERS"
                type="checkbox"
                role="switch"
                checked={callsAndSmsData?.monitorUnknownNumbers || 0}
                onChange={(e) => {
                  handleToggleChange(e);
                  handleChange(); // Mark as changed when toggled
                }}
              />
              <label
                className="form-check-label text-dark"
                htmlFor="MONITOR_UNKNOWN_NUMBERS"
              >
                {getLangTranslation(
                  "CONTACTS_TO_MONITOR_MONITOR_UNKNOWN_NUMBER",
                  "Monitor unknown numbers"
                )}
              </label>
            </div>
          )}

          {activeTab === "ALLOW_BLOCK_CONTACTS" && (
            <div className="form-check">
              <input
                className="form-check-input cursor-pointer"
                name="BLOCK_UNKNOWN_NUMBERS"
                id="BLOCK_UNKNOWN_NUMBERS"
                type="checkbox"
                role="switch"
                checked={callsAndSmsData?.blockUnknownNumbers || 0}
                onChange={(e) => {
                  handleToggleChange(e);
                  handleChange(); // Mark as changed when toggled
                }}
              />
              <label
                className="form-check-label text-dark"
                htmlFor="BLOCK_UNKNOWN_NUMBERS"
              >
                {getLangTranslation(
                  "ALLOW_BLOCK_CALLS_BLOCK_UNKNOWN_NUMBER",
                  "Block unknown numbers"
                )}
              </label>
            </div>
          )}

          {/* {activeTab == "ALLOW_BLOCK_CONTACTS" && ( */}
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="SELECT_ALL"
              name="SELECT_ALL"
              checked={activeTab === 'CONTACTS_TO_MONITOR' ?
                (callsAndSmsData?.contacts?.length > 0 &&
                  callsAndSmsData?.contacts?.filter((item) => !item?.callMonitored)
                    ?.length < 1) : (callsAndSmsData?.contacts?.length > 0 &&
                      callsAndSmsData?.contacts?.filter((item) => !item?.isChecked)
                        ?.length < 1)
              }
              onChange={(e) => handleAllSelect(e, activeTab)}
            />
            <label
              className="form-check-label text-dark"
              htmlFor="flexCheckDefault"
            >
              {activeTab === "CONTACTS_TO_MONITOR"
                ? getLangTranslation(
                  "CONTACTS_TO_MONITOR_SELECT_ALL",
                  "Select All"
                )
                : getLangTranslation(
                  "ALLOW_BLOCK_CALLS_SELECT_ALL",
                  "Select All"
                )}
            </label>
          </div>
          {/* )} */}
        </div>
        <div
          className={`input-group content-336 w-100 ${lang?.isRTL === 1 ? "me-auto" : "ms-auto"
            }`}
        >
          <span
            className={`input-group-text fs-5 text-dark ${lang?.isRTL === 1
                ? "border-start-0 rounded-0 rounded-end ps-0"
                : "border-end-0 pe-0"
              }`}
          >
            <i className="icon-search"></i>
          </span>
          <input
            type="search"
            className={`form-control ${lang?.isRTL === 1
                ? "border-end-0 rounded-0 rounded-start"
                : "border-start-0"
              }`}
            placeholder="Search by name or number"
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setIsFormChanged(true); // Mark as changed when searching
            }}
          />
        </div>
        <div>
          {activeTab == "ALLOW_BLOCK_CONTACTS" && (
            <>
              {/* <button
                className="btn btn-outline-success d-inline-flex align-items-center gap-1 text-nowrap"
                onClick={() => {
                  handleCallsAndSmsStatusChange("ALLOW");
                }}
              >
                <i className="icon-check-fill success-icon fs-5" />{" "}
                {getLangTranslation("APP_WEB_CATEGORY_STATUS_ALLOWED", "Allow")}
              </button>
              <button
                className={`btn btn-outline-danger d-inline-flex align-items-center gap-1 text-nowrap ${lang?.isRTL === 1 ? "me-3" : "ms-3"
                  }`}
                onClick={() => {
                  handleCallsAndSmsStatusChange("BLOCK");
                }}
              >
                <i className="icon-ban danger-icon fs-5" />{" "}
                {getLangTranslation("APP_WEB_CATEGORY_STATUS_BLOCKED", "Block")}
              </button> */}
            </>
          )}
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th className="v-middle">
                <div className="form-check">
                  <label className="form-check-label mt-1" htmlFor="name">
                    {getLangTranslation("ADD_CHILD_NAME", "Name")}
                  </label>
                </div>
              </th>
              <th className="v-middle">
                {getLangTranslation("PHONE_NUMBER", "Phone number")}
              </th>
              {activeTab == "ALLOW_BLOCK_CONTACTS" && (
                <th className="v-middle">
                  {getLangTranslation(
                    "DEVICE_DETAIL_FIND_DEVICE_STATUS",
                    "status"
                  )}
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {filteredContacts?.map((item, index) => (
              <tr>
                <td className="v-middle">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="SINGLE_SELECT"
                      id={item?.contactID}
                      checked={item?.callMonitored}
                      onChange={(e) => {
                        handleCheckBoxChange(e, activeTab);
                        setIsFormChanged(true); // Mark as changed when checkbox is toggled
                      }}
                    />
                    <label className="form-check-label" htmlFor="name">
                      {item?.name}
                    </label>
                  </div>
                </td>
                <td className="v-middle">{item?.number}</td>
                {activeTab == "ALLOW_BLOCK_CONTACTS" && (
                  <td className="v-middle">
                    <button
                      className={`btn d-inline-flex align-items-center gap-1 text-nowrap ms-3 call-sms-button ${item?.callBlocked == 1
                          ? "btn-outline-danger"
                          : "btn-outline-success"
                        }`}
                    >
                      {item?.callBlocked == 1 ? "Block" : "Allowed"}
                    </button>
                  </td>
                )}
              </tr>
            ))}

            {/*activeTab === 'ALLOW_BLOCK_CONTACTS' && filteredContacts?.map((item, index) => (
              <tr>
                <td className="v-middle">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name="SINGLE_SELECT"
                      id={item?.contactID}
                      checked={item?.isChecked}
                      onChange={(e) => handleCheckBoxChange(e, activeTab)}
                    />
                    <label className="form-check-label" htmlFor="name">
                      {item?.name}
                    </label>
                  </div>
                </td>
                <td className="v-middle">{item?.number}</td>
                {activeTab == "ALLOW_BLOCK_CONTACTS" && (
                  <td className="v-middle">
                    <button
                      className={`btn d-inline-flex align-items-center gap-1 text-nowrap ms-3 call-sms-button ${item?.callBlocked == 1
                        ? "btn-outline-danger"
                        : "btn-outline-success"
                        }`}
                    >
                      {item?.callBlocked == 1 ? "Block" : "Allowed"}
                    </button>
                  </td>
                )}
              </tr>
                      ))*/}
          </tbody>
        </table>
        {filteredContacts?.length === 0 && (
          <div className="text-center my-3">
            --- {getLangTranslation("NO_DATA_LOG", "No data found")} ---
          </div>
        )}
      </div>
      {activeTab === "CONTACTS_TO_MONITOR" && (
        <div className="d-flex justify-content-end mt-5 mb-8 w-100">
          <button
            type="button"
            className="btn btn-primary col-sm-2"
            onClick={() => handleCallsAndSmsStatusChange("")}
            disabled={!isFormChanged} // Disable Save button if no changes are made
          >
            <span className="btn-upper-case">
              {getLangTranslation("SAVE", "Save")}
            </span>
          </button>
        </div>
      )}
    </>
  );
};

export default CallAndSms;
